// @flow
export { default } from './PolicyViewer';



// WEBPACK FOOTER //
// ./src/components/policy/PolicyViewer/index.js